import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useSelectedTrade } from '~/context/common/TradeContext';
import { useFinanceInfo } from '~/context/srp/FinanceContext';
import {
  useSendNativeDeviceTypeToDD,
  useSendExperimentsToDataDog
} from '../common';

const useSetDataDogContext = () => {
  const financeInfo = useFinanceInfo();
  const tradeInfo = useSelectedTrade();

  useSendNativeDeviceTypeToDD();
  useSendExperimentsToDataDog();

  useEffect(() => {
    datadogRum.setGlobalContextProperty(
      'softpullStatus',
      financeInfo?.financingType
    );
    datadogRum.setGlobalContextProperty(
      'tradeStatus',
      tradeInfo?.lifeCycleState
    );
  }, [financeInfo.financingType, tradeInfo?.lifeCycleState]);
};

export default useSetDataDogContext;
